import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _styled, { default as _styled2 } from "styled-components";
var _UserApps, _CloseSmall, _Settings, _templateObject;
import { Fragment } from 'react';
import { boldFormatter } from '@crehana/i18n';
import UserApps from '@crehana/icons/fill/UserApps';
import CloseSmall from '@crehana/icons/outline/CloseSmall';
import Settings from '@crehana/icons/outline/Settings';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from 'styled-components';
import { useTranslation } from "../../../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ManualHighQualityWarning = function ManualHighQualityWarning(_ref) {
  var onDismiss = _ref.onDismiss;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "flex items-center justify-between mb-16",
      children: [/*#__PURE__*/_jsxs("p", {
        className: "flex items-center text-secondary-lighter font-subtitle2",
        children: [_UserApps || (_UserApps = /*#__PURE__*/_jsx(UserApps, {
          className: "text-secondary-light fill-current flex-shrink-0 mr-8",
          size: 24,
          ignoreColor: true
        })), t('MANUAL_HIGH_QUALITY_WARNING_TITLE')]
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onDismiss,
        className: "button-base text-base-lighter flex-shrink-0",
        "aria-label": t('CLOSE'),
        children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
          className: "fill-current flex-shrink-0",
          size: 24,
          ignoreColor: true
        }))
      })]
    }), /*#__PURE__*/_jsx(_StyledP, {
      className: "font-body3 text-white mb-4",
      children: t('MANUAL_HIGH_QUALITY_WARNING_DESCRIPTION', {
        formatter: boldFormatter
      })
    }), /*#__PURE__*/_jsxs(_StyledP2, {
      className: "font-body4 text-gray-main",
      children: [t('MANUAL_HIGH_QUALITY_WARNING_CTA'), ' ', _Settings || (_Settings = /*#__PURE__*/_jsx(Settings, {
        className: "fill-current flex-shrink-0",
        size: 16,
        ignoreColor: true
      }))]
    })]
  });
};
export default ManualHighQualityWarning;
var _StyledP = /*#__PURE__*/_styled("p")(_templateObject || (_templateObject = /*#__PURE__*/_taggedTemplateLiteral(["\n          & * {\n            white-space: pre-line;\n          }\n        "])));
var _StyledP2 = /*#__PURE__*/_styled2("p").withConfig({
  componentId: "sc-1kg3k8u-0"
})(["\n          & > svg {\n            margin-bottom: -3px;\n          }\n        "]);